import { $t } from '@/i18n';
import pageLoader from '@loaders/page/loader';

export default {
  type: 'object',
  fields: [
    {
      id: 'type',
      type: 'string',
      title: $t('k_9ff5ee55'),
      enum: [
        { label: $t('k_32559d66'), value: 'page' },
        { label: $t('k_8d6cfa32'), value: 'pagelet' },
        { label: $t('k_886863ff'), value: 'flowNodePagelet' },
      ],
      default: 'page',
    },
    {
      id: 'pageId',
      type: 'string',
      title: $t('k_32559d66'),
      ui: { type: 'XyInnerPageSelector' },
      default: '',
      condition: 'props.type === "page"',
    },
    {
      id: 'pageletId',
      type: 'string',
      title: $t('k_8d6cfa32'),
      ui: { type: 'XyInnerPageletSelector' },
      default: '',
      condition: 'props.type === "pagelet"',
    },
    {
      id: 'flowNodePageletConfig',
      type: 'any',
      title: $t('k_c164976'),
      ui: { type: 'XyInnerFlowNodePageletConfig' },
      default: {
        flowId: '',
        nodeId: '',
      },
      condition: 'props.type === "flowNodePagelet"',
    },
    {
      id: 'params',
      type: 'array',
      title: $t('k_58eb68b8'),
      ui: {
        type: 'XyPageletPropsEditor',
        props: {
          allowBind: true,
          async getPagelet(inputBox) {
            const { pageId, pageletId, type } = inputBox.container.stub.parent.value;
            if (type === 'page' && pageId) {
              const { projectConfig: { id: projectId } } = inputBox.wContext;  // wContext.projectId 可能是空的
              const ans = await pageLoader.getPageDetail({ projectId, pageId });
              const pageConfig = ans?.pageConfig;
              const pagelets = Array.isArray(pageConfig) ? pageConfig : [];
              return pagelets?.find(x => x.id === 'default');
            }
            if (type === 'pagelet' && pageletId) {
              const pageConfig = inputBox?.wContext?.config?.pageConfig;
              const pagelets = Array.isArray(pageConfig) ? pageConfig : [];
              return pagelets?.find(x => x.id === pageletId);
            }
          },
        },
      },
      items: {
        type: 'object',
        fields: [
          { id: 'key', type: 'string' },
          { id: 'value', type: 'string' },
          { id: 'bind', type: 'string' },
        ],
      },
    },
    {
      id: 'loadingMode',
      type: 'string',
      title: $t('k_1263d911'),
      description: $t('k_49efeb54'),
      enum: [
        { label: $t('k_1a462199'), value: 'default' },
        { label: $t('k_166d4347'), value: 'skeleton' },
        { label: $t('k_b90123e9'), value: 'silence' },
      ],
      default: 'default',
    },
    {
      id: 'tips',
      title: $t('k_d0722a3'),
      type: 'object',
      default: null,
      ui: { type: 'XyPageContainerTips' },
      'uc:allowExpr': false,
      'uc:allowReset': false,
    },
  ],
};
